import "./Loader.css";

export function Loader(){
    return(
        <div className="spinner-container">
            <div className="loading-spinner">
                
            </div>
        </div>
    );
}